import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 128 128",
  class: "icon-spin"
}
const _hoisted_2 = ["stroke-width"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tw-inline-block icon-lg static-spinner", `tw-stroke-${$props.color}`])
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, [
      _createElementVNode("circle", {
        class: "path",
        cx: "64",
        cy: "64",
        r: "42",
        fill: "none",
        "stroke-width": $props.thickness
      }, null, 8 /* PROPS */, _hoisted_2)
    ]))
  ], 2 /* CLASS */))
}